import { Grid } from "@mui/material";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { SampleTable } from "@/shared/components/ui";
import { MaterialTransferido } from "@/shared/interfaces";
import { useTableColumnsKit } from "../../hook";
import { InfoVerKitItemStore } from "@/shared/components/ui/InfoModalStore/InfoVerKitItem.store";


export default function InfoKitProductos() {

  //const [open, setOpen] = useState(false);

  const { open, setOpen, productos, setProductos } = InfoVerKitItemStore()

  const { columnViewBase } = useTableColumnsKit();



  return (
    <>
      {
        open && (
          <ScrollableDialogProps
            onCloseIcon={() => {
              setOpen(false)
              setProductos(null);
            }}
            open={open}
            title="Detalle de items"
            minWidth="60%"
            contentNode={
              <Grid container >
                <Grid item xs={12} >
                  <SampleTable<MaterialTransferido>
                    rowNumber={true}
                    columns={columnViewBase}
                    data={productos ?? []}
                    enableTopToolbar={true}
                  />
                </Grid>
              </Grid>
            }
          />
        )
      }
    </>
  )
}